import React, { useState, useCallback } from 'react';
import { BlockStack, InlineStack, Text, Popover, Button, Badge, TextField, FormLayout, Box } from '@shopify/polaris';
import { SpacingMarkup } from '../common/Placeholder';

const ViewRuleField = ({ rule }) => {
    const [popoverActive, setPopoverActive] = useState(false);

    const togglePopoverActive = useCallback(
        () => setPopoverActive((popoverActive) => !popoverActive),
        [],
    );

    const formatDate = (dateString) => {
        if (!dateString) return 'N/A';
        return new Date(dateString).toLocaleDateString('en-US', {
            year: 'numeric',
            month: 'short',
            day: 'numeric',
            hour: '2-digit',
            minute: '2-digit'
        });
    };

    const getStatusBadge = (status) => {
        const statusMap = {
            'active': { tone: 'success', children: 'Active' },
            'inactive': { tone: 'critical', children: 'Inactive' }
        };
        return statusMap[status] || { tone: 'info', children: status };
    };

    const activator = (
        <Button onClick={(e) => {
            e.stopPropagation();
            togglePopoverActive();
        }} variant='plain'>
            View Rule
        </Button>
    );

    return (
        <Popover
            active={popoverActive}
            activator={activator}
            onClose={togglePopoverActive}
            preferredAlignment='left'
            preferredPosition='below'
        >
            <BlockStack gap='025'>
                <Box padding="400">
                    <InlineStack align='space-between' blockAlign='start'>
                        <BlockStack gap="100">
                            <Text variant="headingMd" as="h3">
                                {rule?.name || 'Unnamed Rule'}
                            </Text>
                            
                            {rule?.description && (
                                <Text variant="bodyMd" as="p" color="subdued">
                                    {rule.description}
                                </Text>
                            )}
                        </BlockStack>
                        <Badge {...getStatusBadge(rule?.status)} />
                    </InlineStack>
                    <SpacingMarkup />
                    <BlockStack gap="200">
                        <Text variant="headingMd" as="h3">
                            Formula Details
                        </Text>
                        <FormLayout>
                            <FormLayout.Group condensed>
                                <TextField
                                    label="Formula Type"
                                    value={rule?.formulaType || 'N/A'}
                                    readOnly
                                />
                                <TextField
                                    label="Rounding"
                                    value={rule?.formula?.rounding || 'N/A'}
                                    readOnly
                                />
                            </FormLayout.Group>
                            <TextField
                                label="Formula Expression"
                                value={rule?.formula?.expression || 'N/A'}
                                multiline={2}
                                readOnly
                            />
                        </FormLayout>
                    </BlockStack>
                    <SpacingMarkup />
                    <BlockStack gap="200">
                        <Text variant="headingMd" as="h3">
                            Timestamps
                        </Text>
                        <FormLayout>
                            <FormLayout.Group condensed>
                                <TextField
                                    label="Last Applied At"
                                    value={formatDate(rule?.settings?.last_applied_at) || 'N/A'}
                                    readOnly
                                />
                                <TextField
                                    label="Created At"
                                    value={formatDate(rule?.createdAt) || 'N/A'}
                                    readOnly
                                />
                            </FormLayout.Group>
                                <TextField
                                    label="Updated At"
                                    value={formatDate(rule?.updatedAt) || 'N/A'}
                                    readOnly
                                />
                        </FormLayout>
                    </BlockStack>
                </Box>
            </BlockStack>
        </Popover>
    )
};

export default ViewRuleField;
